import { ActivityLog } from './activity-log.model';
import { Tag } from './tag.model';

export class Upload {
  uploadId: number;
  status: UploadFileStatus;
  name: string;
  patientId: string;
  dataTypeId: number;
  dataType?: string;
  visitId: string;
  createdAt: string;
  batch?: string;
  altId?: string;
  size: string;
  s3Guid: string;
  metaData?: string;
  uploadUserId: number;
  resubmissionForUploadId?: number;
}

export enum UploadFileStatus {
  incomplete = 'incomplete',
  pendingApproval = 'pendingApproval',
  approved = 'approved',
  denied = 'denied',
  resubmitted = 'resubmitted',
  deleted = 'deleted'
}



// WEBPACK FOOTER //
// ./src/app/models/upload.model.ts